import React from 'react';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { YES_NO_OPTIONS } from '../hooks/useCallAnalysis';
import { ButtonWrapper, Row, SearchBar } from '../callAnalysis.styles';

const CallAnalysisSearchBar = ({
	formik,
	consultants,
	managers,
	marketsOptions,
}) => (
	<SearchBar>
		<Row>
			<Input
				type='date'
				name='From'
				id='fromDate'
				value={formik.values.fromDate}
				onChange={formik.handleChange}
				width={80}
				inputWidth={140}
				color={Colors.darkBlue}
			/>
			<Input
				type='date'
				name='To'
				id='toDate'
				value={formik.values.toDate}
				onChange={formik.handleChange}
				width={80}
				inputWidth={140}
				color={Colors.darkBlue}
			/>
			<SelectInput
				name='Consultant'
				selected={formik.values.consultant}
				setSelected={(value) => formik.setFieldValue('consultant', value)}
				options={consultants}
				width={100}
				selectWidth={200}
				color={Colors.darkBlue}
			/>
			<SelectInput
				name='Team leader'
				selected={formik.values.team_leader}
				setSelected={(value) => formik.setFieldValue('team_leader', value)}
				options={managers}
				width={100}
				selectWidth={200}
				color={Colors.darkBlue}
			/>
		</Row>
		<Row>
			<SelectInput
				name='Market'
				selected={formik.values.market}
				setSelected={(value) => formik.setFieldValue('market', value)}
				options={marketsOptions}
				width={100}
				selectWidth={200}
				color={Colors.darkBlue}
			/>
			<SelectInput
				name='Critical error'
				selected={formik.values.has_critical_error}
				setSelected={(value) =>
					formik.setFieldValue('has_critical_error', value)
				}
				options={YES_NO_OPTIONS}
				width={120}
				selectWidth={120}
				color={Colors.darkBlue}
			/>
		</Row>
		<ButtonWrapper>
			<ActionButton defaultText='Search' onClick={formik.handleSubmit} />
		</ButtonWrapper>
	</SearchBar>
);

export default CallAnalysisSearchBar;
